module.exports = __webpack_public_path__ + "media/images/products/category/7-f4f0756d9933f641fa2d8853fa5cd7c7.jpg";